import {ShouldRevalidateFunction} from 'react-router-dom'

let forceRevalidate = true

export function markToDoForRevalidation() {
  forceRevalidate = true
}

export const todoRevalidator: ShouldRevalidateFunction = ({
  currentParams,
  nextParams,
  formMethod,
}) => {
  if (formMethod === 'post') {
    return true
  }

  if (forceRevalidate) {
    forceRevalidate = false
    return true
  }

  return currentParams.todoId != nextParams.todoId
}
